<div class="bmark-summary__spot-risk__container">
  <div
    style="display: flex; flex-direction: row; align-items: stretch"
    class="bmark-summary__spot-risk__body"
  >
    <bmark-spot-risk-blotter
      style="display: flex; flex-direction: column; flex: 1 1 auto"
      #bmarkRiskView
      [publishGridDataUpdateInfo]="true"
      [fixingName]="fixing"
    >
    </bmark-spot-risk-blotter>
  </div>
</div>
